<template>
  <div class="blog-detail-wrapper">

    <!-- blogs -->
    <b-row class="blog-list-wrapper">
      <b-card no-body class="col-md-12">
        <b-card-header class="pb-50">
          <h5>
            Фильтры
          </h5>
        </b-card-header>
        <b-card-body>
          <!-- Запрос уходит только по «Применить» (или Enter в любом поле формы) -->
          <b-form @submit.prevent="applyFilters">
            <b-row>
              <b-col
                  cols="12"
                  md="4"
                  class="mb-1"
              >
                <label for="search-query">Запрос</label>
                <b-form-input
                    id="search-query"
                    v-model="filters.searchQuery"
                    placeholder="Зеленая миля"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-type">Тип</label>
                <b-form-select
                    id="filter-type"
                    v-model="filters.type"
                    :options="typeOptions"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-animation">Анимация</label>
                <b-form-select
                    id="filter-animation"
                    v-model="filters.animation"
                    :options="animationOptions"
                />
              </b-col>
              <b-col
                  cols="12"
                  md="4"
                  class="mb-1"
              >
                <label for="sort-select">Сортировка</label>
                <b-form-select
                    id="sort-select"
                    v-model="filters.sortValue"
                    :options="sortOptions"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-year-from">Год от</label>
                <b-form-input
                    id="filter-year-from"
                    v-model.number="filters.yearFrom"
                    type="number"
                    placeholder="1990"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-year-to">Год до</label>
                <b-form-input
                    id="filter-year-to"
                    v-model.number="filters.yearTo"
                    type="number"
                    placeholder="2026"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-genre">Жанр</label>
                <b-form-input
                    id="filter-genre"
                    v-model="filters.genre"
                    placeholder="боевик"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-country">Страна</label>
                <b-form-input
                    id="filter-country"
                    v-model="filters.country"
                    placeholder="США"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-has-franchise">Франшиза</label>
                <b-form-select
                    id="filter-has-franchise"
                    v-model="filters.hasFranchise"
                    :options="presenceOptions"
                />
              </b-col>
              <b-col
                  cols="3"
                  md="1"
                  class="mb-1"
              >
                <label for="filter-difficulty-from">Сложн. от</label>
                <b-form-input
                    id="filter-difficulty-from"
                    v-model.number="filters.difficultyFrom"
                    type="number"
                    min="0"
                    max="10"
                />
              </b-col>
              <b-col
                  cols="3"
                  md="1"
                  class="mb-1"
              >
                <label for="filter-difficulty-to">до</label>
                <b-form-input
                    id="filter-difficulty-to"
                    v-model.number="filters.difficultyTo"
                    type="number"
                    min="0"
                    max="10"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-rating-kp-min">КП от</label>
                <b-form-input
                    id="filter-rating-kp-min"
                    v-model.number="filters.ratingKpMin"
                    type="number"
                    step="0.1"
                    placeholder="7"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-votes-kp-min">Оценок КП от</label>
                <b-form-input
                    id="filter-votes-kp-min"
                    v-model.number="filters.votesKpMin"
                    type="number"
                    placeholder="10000"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-rating-imdb-min">IMDb от</label>
                <b-form-input
                    id="filter-rating-imdb-min"
                    v-model.number="filters.ratingImdbMin"
                    type="number"
                    step="0.1"
                    placeholder="7"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-votes-imdb-min">Оценок IMDb от</label>
                <b-form-input
                    id="filter-votes-imdb-min"
                    v-model.number="filters.votesImdbMin"
                    type="number"
                    placeholder="10000"
                />
              </b-col>
              <b-col
                  cols="4"
                  md="1"
                  class="mb-1"
              >
                <label for="filter-has-notion">Notion</label>
                <b-form-select
                    id="filter-has-notion"
                    v-model="filters.hasNotion"
                    :options="presenceOptions"
                />
              </b-col>
              <b-col
                  cols="4"
                  md="1"
                  class="mb-1"
              >
                <label for="filter-has-frames">Кадры</label>
                <b-form-select
                    id="filter-has-frames"
                    v-model="filters.hasFrames"
                    :options="presenceOptions"
                />
              </b-col>
              <b-col
                  cols="4"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-has-posters">Постеры</label>
                <b-form-select
                    id="filter-has-posters"
                    v-model="filters.hasPosters"
                    :options="presenceOptions"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  cols="12"
                  md="3"
                  class="mb-1"
              >
                <label for="filter-person">Актёр / режиссёр</label>
                <b-form-input
                    id="filter-person"
                    v-model="filters.person"
                    placeholder="Том Хэнкс"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-person-role">Роль</label>
                <b-form-select
                    id="filter-person-role"
                    v-model="filters.personRole"
                    :options="personRoleOptions"
                />
              </b-col>
              <b-col
                  cols="6"
                  md="2"
                  class="mb-1 d-flex align-items-end"
              >
                <b-form-checkbox
                    v-model="filters.personBest"
                    class="mb-50"
                >
                  только ★ best
                </b-form-checkbox>
              </b-col>
              <b-col
                  cols="12"
                  md="3"
                  class="mb-1"
              >
                <label for="filter-list">Список</label>
                <v-select
                    input-id="filter-list"
                    v-model="filters.listId"
                    :options="listOptions"
                    :reduce="option => option.id"
                    label="label"
                    placeholder="Любой"
                />
              </b-col>
              <b-col
                  cols="12"
                  md="2"
                  class="mb-1"
              >
                <label for="filter-cluster">Кластер</label>
                <b-form-select
                    id="filter-cluster"
                    v-model="filters.cluster"
                    :options="clusterOptions"
                />
              </b-col>
            </b-row>
            <div class="d-flex">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
              >
                Применить
              </b-button>
              <b-button
                  variant="outline-secondary"
                  @click="resetFilters"
              >
                Сбросить
              </b-button>
            </div>
          </b-form>
        </b-card-body>
      </b-card>

      <b-overlay
          :show="isLoading"
          rounded="sm"
      >
        <b-table
            ref="refMoviesListTable"
            :items="moviesList"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="No matching records found"
            class="position-relative"
        >
          <!-- Column: Id -->
          <template #cell(id)="data">
            #{{ data.item.id }}
          </template>

          <!-- Column: Movie -->
          <template #cell(movie)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-link
                    :to="{name: 'movie-view', params: { id: data.item.id }}"
                >
                  <b-img
                      width="120"
                      thumbnail
                      rounded
                      fluid
                      class="poster"
                      :class="(isFilm(data.item.type)) ? 'poster-movie' : 'poster-series'"
                      :src="data.item.poster_preview"
                  />
                </b-link>
              </template>
              <span class="font-weight-bold d-block">
              <b-link
                  :to="{name: 'movie-view', params: { id: data.item.id }}"
                  class="h2"
                  :class="(isFilm(data.item.type)) ? 'title-movie' : 'title-series'"
              >{{ data.item.title_ru }}</b-link>
              <span
                  v-if="data.item.year"
                  class="movie-year text-muted ml-50"
              >{{ data.item.year }}</span>
                </span>
              <small class="text-muted">{{ data.item.title_en }}</small>
              <template v-if="data.item.staff_preview">
                <div
                    v-for="staffRow in staffRows(data.item.staff_preview)"
                    :key="staffRow.label"
                    class="staff-row"
                >
                  <span class="text-muted">{{ staffRow.label }}:</span>
                  <template v-for="(person, index) in staffRow.people">
                    <b-link
                        :key="person.id"
                        :to="{name: 'person-view', params: {id: person.id}}"
                        :class="{'font-weight-bolder': person.best}"
                    >{{ person.best ? '★ ' : '' }}{{ person.name }}</b-link><span
                        v-if="index < staffRow.people.length - 1"
                        :key="`comma-${person.id}`"
                    >, </span>
                  </template>
                  <span
                      v-if="staffRow.rest > 0"
                      class="text-muted"
                  > +{{ staffRow.rest }}</span>
                </div>
              </template>
              <span
                  v-for="franchise in data.item.franchises"
                  :key="franchise.id"
                  class="d-block text-nowrap mt-25"
              >
                <b-link
                    :to="{name: 'franchise-view', params: {id: franchise.id}}"
                    class="franchise-chip"
                >
                  <feather-icon
                      icon="LayersIcon"
                      size="18"
                  />
                  <span>{{ franchise.title }}<template v-if="franchise.part_number"> · {{ franchise.part_number }}</template></span>
                </b-link>
              </span>
            </b-media>
          </template>

          <!-- Column: Type -->
          <template #cell(type)="data">
            <feather-icon :icon="GetTypeIcon(data.item.type)" v-b-tooltip.hover.top="data.item.type"/>
          </template>

          <!-- Column: Animation -->
          <template #cell(animation)="data">
            {{ getAnimationText(data.item.animation) }}
          </template>

          <!-- Column: Ratings (КП + IMDb одним блоком) -->
          <template #cell(ratings)="data">
            <div class="rating-block">
              <div class="rating-row">
                <b-link
                    v-if="data.item.kp_id"
                    :href="`https://kinopoisk.ru/film/${data.item.kp_id}`"
                    target="_blank"
                >
                  <b-img
                      :src="kinopoiskIcon"
                      class="rating-source-img rating-source-img-kp"
                      alt="КП"
                      v-b-tooltip.hover.top="'Открыть на Кинопоиске'"
                  />
                </b-link>
                <b-img
                    v-else
                    :src="kinopoiskIcon"
                    class="rating-source-img rating-source-img-kp"
                    alt="КП"
                />
                <span
                    class="font-weight-bold font-large-1 mr-50"
                    :class="ratingColorClass(data.item.rating_kp)"
                >{{ ratingFmt(data.item.rating_kp) }}</span>
                <small class="text-muted">{{ formatNumber(data.item.votes_kp) }}</small>
              </div>
              <div class="rating-row">
                <b-link
                    v-if="data.item.imdb_id"
                    :href="`https://www.imdb.com/title/${data.item.imdb_id}/`"
                    target="_blank"
                >
                  <b-img
                      :src="imdbIcon"
                      class="rating-source-img rating-source-img-imdb"
                      alt="IMDb"
                      v-b-tooltip.hover.top="'Открыть на IMDb'"
                  />
                </b-link>
                <b-img
                    v-else
                    :src="imdbIcon"
                    class="rating-source-img rating-source-img-imdb"
                    alt="IMDb"
                />
                <span
                    class="font-weight-bold mr-50"
                    :class="ratingColorClass(data.item.rating_imdb)"
                >{{ ratingFmt(data.item.rating_imdb) }}</span>
                <small class="text-muted">{{ formatNumber(data.item.votes_imdb) }}</small>
              </div>
            </div>
          </template>

          <!-- Column: Creation Date -->
          <template #cell(created_at)="data">
            <span class="text-nowrap mr-1">
               {{ formatDate(data.item.created_at) }}
            </span>
          </template>

          <!-- Column: Updated Date time -->
          <template #cell(updated_at)="data">
            <span class="text-nowrap mr-1">
               {{
                formatDate(data.item.updated_at, {
                  month: 'numeric',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                })
              }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">

            </div>
          </template>
        </b-table>
      </b-overlay>

      <b-col cols="12">
        <!-- pagination -->
        <div class="my-2">
          <b-pagination
              v-model="page"
              per-page="20"
              align="center"
              :total-rows="total"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-col>
    </b-row>

    <!--/ blogs -->

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BCardHeader,
  BTable,
  BButton,
  BFormSelect,
  BFormCheckbox,
  BForm,
  VBTooltip,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {avatarText, kFormatter, formatDate, ratingFmt, formatNumber} from '@core/utils/filter'
import store from "@/store";
import {computed, onUnmounted, ref, watch} from "@vue/composition-api";
import movieStoreModule from "@/views/database/movieStoreModule";
import kinopoiskIcon from '@/assets/images/icons/kinopoisk.svg'
import imdbIcon from '@/assets/images/icons/imdb.svg'

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BCardHeader,
    BTable,
    BButton,
    BFormSelect,
    BFormCheckbox,
    BForm,
    vSelect,
  },
  data() {
    return {
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  methods: {
    kFormatter,
    formatDate,
    ratingFmt,
    formatNumber,
    // Прежняя цветовая логика рейтинга: <5 красный, <7 серый, иначе зелёный
    ratingColorClass(rating) {
      return (rating < 5) ? 'text-danger' : (rating < 7) ? 'text-gray' : 'text-success'
    },
    // Строки «Актёры» / «Режиссёры»: бэкенд уже обрезал списки, остаток показываем как «+Х»
    staffRows(staffPreview) {
      return [
        {label: 'Актёры', people: staffPreview.actors, rest: staffPreview.actors_total - staffPreview.actors.length},
        {label: 'Режиссёры', people: staffPreview.directors, rest: staffPreview.directors_total - staffPreview.directors.length},
      ].filter(staffRow => staffRow.people.length > 0)
    },
    GetTypeIcon(type) {
      if (type === 'FILM') {
        return 'FilmIcon'
      }
      if ((type === 'TV_SERIES') || (type === 'MINI_SERIES')) {
        return 'TvIcon'
      }
      if (type === 'TV_SHOW') {
        return 'CameraIcon'
      }
      if (type === 'UNKNOWN') {
        return 'InfoIcon'
      }
      if (type === 'VIDEO') {
        return 'VideoIcon'
      }
      return 'AlertTriangleIcon'
    },
    isFilm(type) {
      if (type === 'FILM') {
        return true
      }
      if ((type === 'TV_SERIES') || (type === 'MINI_SERIES')) {
        return false
      }
      if (type === 'TV_SHOW') {
        return false
      }
      if (type === 'UNKNOWN') {
        return false
      }
      if (type === 'VIDEO') {
        return true
      }
      return false
    }
  },
  setup() {
    const STORE_MODULE_NAME = 'movies'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, movieStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const page = ref(1)
    const total = ref(null)
    const isLoading = ref(false)

    // --- Фильтры: правится черновик, в запрос уходит снимок, сделанный по «Применить» ---
    const defaultFilters = () => ({
      searchQuery: null,
      type: null,
      animation: null,
      sortValue: 'id:asc',
      yearFrom: null,
      yearTo: null,
      genre: null,
      country: null,
      hasFranchise: null,
      difficultyFrom: null,
      difficultyTo: null,
      ratingKpMin: null,
      votesKpMin: null,
      ratingImdbMin: null,
      votesImdbMin: null,
      hasNotion: null,
      hasFrames: null,
      hasPosters: null,
      person: null,
      personRole: null,
      personBest: false,
      listId: null,
      cluster: null,
    })
    const filters = ref(defaultFilters())
    const appliedFilters = ref(defaultFilters())

    const typeOptions = [
      {value: null, text: 'Все типы'},
      {value: 'FILM', text: 'Фильм'},
      {value: 'TV_SERIES', text: 'Сериал'},
      {value: 'MINI_SERIES', text: 'Мини-сериал'},
      {value: 'TV_SHOW', text: 'ТВ-шоу'},
      {value: 'VIDEO', text: 'Видео'},
    ]

    const animationOptions = [
      {value: null, text: 'Любая'},
      {value: 0, text: 'Нет'},
      {value: 1, text: 'Да'},
      {value: 2, text: 'Частично'},
    ]

    const presenceOptions = [
      {value: null, text: 'Все'},
      {value: '1', text: 'Есть'},
      {value: '0', text: 'Нет'},
    ]

    const personRoleOptions = [
      {value: null, text: 'Любая роль'},
      {value: 'ACTOR', text: 'Актёр'},
      {value: 'DIRECTOR', text: 'Режиссёр'},
    ]

    // --- Сортировка: статичный селект вместо сортировки колонок ---
    const sortOptions = [
      {value: 'id:asc', text: 'ID (по умолчанию)'},
      {value: 'created_at:desc', text: 'Дата добавления: новые'},
      {value: 'created_at:asc', text: 'Дата добавления: старые'},
      {value: 'updated_at:desc', text: 'Дата изменения: свежие'},
      {value: 'year:desc', text: 'Год: новые'},
      {value: 'year:asc', text: 'Год: старые'},
      {value: 'rating_kp:desc', text: 'Рейтинг КП: по убыванию'},
      {value: 'rating_imdb:desc', text: 'Рейтинг IMDb: по убыванию'},
      {value: 'votes_kp:desc', text: 'Оценок КП: по убыванию'},
      {value: 'votes_imdb:desc', text: 'Оценок IMDb: по убыванию'},
      {value: 'title_ru:asc', text: 'Название: А–Я'},
    ]

    // --- Справочники для селектов «Список» и «Кластер» ---
    const movieLists = ref([])
    const movieClusters = ref([])
    const listTypeLabels = {movies: 'фильмы', series: 'сериалы'}
    const listOptions = computed(() => movieLists.value.map(list => ({
      id: list.id,
      label: `${list.title} (${listTypeLabels[list.type] || list.type})`,
    })))
    // Наличие кластера и конкретный кластер — один селект: 'with' / 'without' / id
    const clusterOptions = computed(() => [
      {value: null, text: 'Любой'},
      {value: 'with', text: 'С кластером'},
      {value: 'without', text: 'Без кластера'},
      ...movieClusters.value.map(cluster => ({value: cluster.id, text: cluster.title})),
    ])
    store.dispatch('movies/fetchMovieListOptions')
        .then(response => {
          movieLists.value = response.data.data
        })
        .catch(() => {})
    store.dispatch('movies/fetchMovieClusters')
        .then(response => {
          movieClusters.value = response.data.data
        })
        .catch(() => {})

    // Table Handlers
    const tableColumns = [
      {key: 'id', label: '#'},
      {key: 'movie', label: 'Фильм'},
      {key: 'type', label: 'Тип'},
      {key: 'animation', label: 'Анимация'},
      {key: 'ratings', label: 'Рейтинг'},
      {key: 'created_at', label: 'Дата добавления'},
      {key: 'updated_at', label: 'Дата изменения'},
    ]

    const moviesList = ref([])

    // Очищенное number-поле даёт '', а 0 — валидное значение (анимация «Нет», сложность 0)
    const isFilled = value => value !== null && value !== undefined && value !== ''

    // В запрос уходят только заполненные фильтры из применённого снимка
    const buildParams = () => {
      const applied = appliedFilters.value
      const [sortField, sortDirection] = applied.sortValue.split(':')
      const params = {
        page: page.value,
        per_page: 20,
        sort: sortField,
        sortDesc: sortDirection === 'desc',
      }
      if (applied.searchQuery) params.q = applied.searchQuery
      if (applied.type) params.type = applied.type
      if (isFilled(applied.animation)) params.animation = applied.animation
      if (applied.yearFrom) params.year_from = applied.yearFrom
      if (applied.yearTo) params.year_to = applied.yearTo
      if (applied.genre) params.genre = applied.genre
      if (applied.country) params.country = applied.country
      if (isFilled(applied.hasFranchise)) params.has_franchise = applied.hasFranchise
      if (isFilled(applied.difficultyFrom)) params.difficulty_from = applied.difficultyFrom
      if (isFilled(applied.difficultyTo)) params.difficulty_to = applied.difficultyTo
      if (applied.ratingKpMin) params.rating_kp_min = applied.ratingKpMin
      if (applied.votesKpMin) params.votes_kp_min = applied.votesKpMin
      if (applied.ratingImdbMin) params.rating_imdb_min = applied.ratingImdbMin
      if (applied.votesImdbMin) params.votes_imdb_min = applied.votesImdbMin
      if (isFilled(applied.hasNotion)) params.has_notion = applied.hasNotion
      if (isFilled(applied.hasFrames)) params.has_frames = applied.hasFrames
      if (isFilled(applied.hasPosters)) params.has_posters = applied.hasPosters
      if (applied.person) params.person = applied.person
      if (applied.personRole) params.person_role = applied.personRole
      if (applied.personBest) params.person_best = 1
      if (applied.listId) params.list_id = applied.listId
      if (applied.cluster === 'with') params.has_cluster = 1
      else if (applied.cluster === 'without') params.has_cluster = 0
      else if (applied.cluster) params.cluster_id = applied.cluster
      return params
    }

    // Новый запрос отменяет ещё не ответивший предыдущий — ответы не перетирают друг друга
    let activeRequest = null

    const fetchPage = () => {
      if (activeRequest) activeRequest.abort()
      const controller = new AbortController()
      activeRequest = controller

      isLoading.value = true
      store.dispatch('movies/fetchMoviesCancellable', {params: buildParams(), signal: controller.signal})
          .then(response => {
            moviesList.value = response.data.data
            total.value = response.data.meta.total
          })
          .catch(() => {})
          .finally(() => {
            // Оверлей снимает только последний запрос: отменённый завершается раньше нового
            if (activeRequest === controller) {
              activeRequest = null
              isLoading.value = false
            }
          })
    }

    // Применение фильтров сбрасывает на первую страницу; смену страницы ловит watch
    const applyFilters = () => {
      appliedFilters.value = {...filters.value}
      if (page.value !== 1) {
        page.value = 1
        return
      }
      fetchPage()
    }

    const resetFilters = () => {
      filters.value = defaultFilters()
      applyFilters()
    }

    fetchPage()

    watch(page, () => {
      fetchPage()
    })

    // Уход со страницы обрывает висящий запрос
    onUnmounted(() => {
      if (activeRequest) activeRequest.abort()
    })

    const getAnimationText = (val) => {
      if (val === 1) return 'Да'
      if (val === 2) return 'Частично'
      return 'Нет'
    }

    return {
      tableColumns,
      filters,
      typeOptions,
      animationOptions,
      presenceOptions,
      personRoleOptions,
      sortOptions,
      listOptions,
      clusterOptions,
      moviesList,
      page,
      total,
      avatarText,
      applyFilters,
      resetFilters,
      isLoading,
      kinopoiskIcon,
      imdbIcon,
      getAnimationText,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.poster-movie {
  border-color: #006d8d;
}

.poster-series {
  border-color: #b97500;
}

.poster {
  border-width: 2px;
}

.title-movie {
  color: #006d8d;
}

.title-series {
  color: #b97500;
}

// Год отделён от названия и приглушён
.movie-year {
  font-size: 1.3rem;
  font-weight: 400;
}

// Актёры/режиссёры под названием: одна строка через запятую
.staff-row {
  margin-top: 2px;
  font-size: 0.95rem;
}

// Объединённый блок рейтингов КП/IMDb
.rating-block {
  min-width: 160px;
}

.rating-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

// Иконки источников на фирменных плашках: белый глиф КП на оранжевом, чёрный IMDb на жёлтом
.rating-source-img {
  width: 26px;
  height: 26px;
  padding: 4px;
  margin-right: 8px;
  border-radius: 5px;
  flex-shrink: 0;
}

.rating-source-img-kp {
  background: #f50;
}

.rating-source-img-imdb {
  background: #f5c518;
}

// Плашка франшизы: свой chip вместо b-badge — у бэджа em-паддинги и line-height
// давят крупную иконку, тут размеры полностью под контролем
.franchise-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 0.358rem;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  font-size: 1.15rem;
  font-weight: 500;
  line-height: 1.2;

  svg {
    margin-right: 6px;
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(115, 103, 240, 0.2);
    color: #7367f0;
  }
}
</style>
